import { AlertTriangle, Database } from "lucide-react";
import { publicDailyReportToken } from "./public-daily-report-location";
import { usePublicDailyReportSnapshot } from "./usePublicDailyReportSnapshot";
import { ProductionDailyReportContent } from "./ProductionDailyReportContent";
export { ProductionDailyReportContent } from "./ProductionDailyReportContent";
export type { SnapshotView } from "./public-daily-report-types";
import "./public-production-daily-report.css";

function ErrorState({ message }: { message: string }) {
  return <main className="pdr-state"><AlertTriangle aria-hidden="true"/><h1>Rapor açılamadı</h1><p>{message}</p><a href="/">Ana ekrana dön</a></main>;
}

export default function PublicProductionDailyReport() {
  const token = publicDailyReportToken(window.location);
  const {data, error} = usePublicDailyReportSnapshot({token});
  if (error) return <ErrorState message={error}/>;
  if (!data) return <main className="pdr-state" aria-live="polite"><Database aria-hidden="true"/><h1>Üretim raporu yükleniyor</h1><p>Kaydedilmiş plan ve üretim bilgileri alınıyor.</p></main>;
  return <ProductionDailyReportContent data={data}/>;
}
